module.exports = __webpack_public_path__ + "static/media/SpeakUp_LOGO.1008a920.svg";